<template>
  <info-dialog v-model="isActive" max-width="500px" :title="`${$t('tecnici.label.stats')} ${stats.nome} ${stats.cognome}`">

    <v-flex xs12>
      <div><span>{{ $t('tecnici.label.stats_numero_report') }}: </span><b>{{ stats.numero_report }}</b></div>
      <div><span>{{ $t('tecnici.label.stats_fatturato') }}: </span><b>{{ stats.fatturato }}€</b></div>
      <div><span>{{ $t('tecnici.label.stats_fatturato_pezzi') }}: </span><b>{{ stats.fatturato_pezzi }}€</b></div>
      <div><span>{{ $t('tecnici.label.stats_media_pezzi') }}: </span><b>{{ stats.media_pezzi }}</b></div>
      <div><span>{{ $t('tecnici.label.stats_media_compilazione') }}: </span><b>{{ stats.media_compilazione }} min</b></div>
    </v-flex>

  </info-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import InfoDialog from '@/components/base/InfoDialog'

export default {
    name: 'TecnicoStatsDialog',
    mixins: [Toggleable],
    components: { InfoDialog },
    data: () => ({
        stats: {}
    }),
    methods: {
        show (tecnico) {
            this.isActive = true
            this.stats = tecnico
        }
    }
}
</script>
